import './imageloader.less'

import {m, Picture} from '@codeurs/front'
import {FunctionComponent, useState} from 'react'
import {ImageType} from 'types'
import {style} from 'util/style'

const styles = style('imageloader', ['loadericon'])

export type ImageLoaderType = {[key: string]: any}

export const ImageLoader: FunctionComponent<
  ImageLoaderType & {
    alt?: string
    gif?: boolean
    ratio?: number
    image_width?: string
    header?: boolean
  }
> = ({image, ratio, gif = false, header, image_width, alt, ...props}) => {
  const [loaded, setLoaded] = useState(false)
  if (!image) return null

  const mutatableImage = {...image}
  if (gif && image.src.indexOf('://') < 0) {
    mutatableImage.src = window.location.origin + image.src
  }
  const MAX_WIDTH = 800

  let useWidth = image.width
  if (image_width) useWidth = image_width
  if (MAX_WIDTH < useWidth) useWidth = MAX_WIDTH

  if (mutatableImage.meta) delete mutatableImage.meta
  if (mutatableImage.size) delete mutatableImage.size

  mutatableImage.alt =
    alt ||
    image.alt ||
    image.title
      .split('/')
      .pop()
      .split('.')
      .slice(0, -1)
      .join('.')
      .replaceAll('-', ' ')

  return (
    <div
      className={styles.is({loaded}).mod({ratio: !!ratio}).mergeProps(props)}
    >
      <Picture
        fit={ratio && 'cover'}
        {...mutatableImage}
        className={styles('image').toString()}
        onload={() => {
          setLoaded(true)
        }}
        style={{
          width: '100%',
          maxWidth: useWidth + 'px'
        }}
      />
      {(image.alt || alt) && (
        <span className={styles('copyright')}>{image.alt || alt}</span>
      )}
      {!loaded && <LoaderIcon />}
    </div>
  )
}

export const LoaderIcon = () => <div class={styles.loadericon}></div>

export const isGif = (image: ImageType) => {
  if (!image || !image.src) return false
  return image.src.substring(-4) === '.gif'
}
